import { TextLargeParagraph } from '@carboncopyco/ui';
import { TitleCard } from '../../InfoPageCards/TitleCard';
import { ClonePageTabLayout } from '../ClonePageTabLayout';
import { PagesTable } from './PagesTable';

export const DataTab = () => {
  return (
    <ClonePageTabLayout>
      <div>
        <TitleCard
          radius
          header={
            <div className="flex p-5">
              <TextLargeParagraph
                color="text-ds-natural-700"
                label="URLS"
              />
            </div>
          }
        >
          <PagesTable />
        </TitleCard>
      </div>
    </ClonePageTabLayout>
  );
};
